import { collection } from "@Api/helpers";
import Factory from "@Shared/Factory";
import api from "..";
export const find = (userId) => {
    const url = `/admin/users/${userId}`;
    return api.get(url).then((result) => Factory.User(result.data.item));
};
export const get = (callback) => {
    const url = `/admin/users`;
    return collection((data) => callback(Factory.User(data)), url);
};
export const post = (user) => {
    return api
        .post(`/admin/users`, user.data)
        .then((result) => {
        return Factory.User(result.data.item);
    })
        .catch((error) => {
        throw error.response.data;
    });
};
export const put = (user) => {
    return api.put(`/admin/users/${user.id}`, user.data).then((result) => {
        return Factory.User(result.data.item);
    });
};
export const del = (user) => {
    return api.delete(`/admin/users/${user.id}`).then((result) => {
        return result.data.item;
    });
};
